import React from 'react';
import styled from 'styled-components';
import { formatDateWithTime } from './utils';

const Wrapper = styled.p``;

interface Props extends React.HTMLAttributes<any> {
  dateTime: string;
  pattern?: string;
  as?: any;
}

export function DateDisplay({ dateTime, pattern = "dd MMMM yyyy 'à' HH'h'mm", ...props }: Props) {
  if (!dateTime) {
    return null;
  }

  return <Wrapper {...props}>{formatDateWithTime(dateTime, pattern)}</Wrapper>;
}
